import { IFluidObject } from '@fluidframework/core-interfaces';
import { Pairing, TelemetryConfig } from '../MessageTypes';

/**
 * Proxy host telemetry configuration to be used by the container
 * @param scope An IFluidObject object that will be available to all containers/components loaded
 */
export function getHostSideTelemetryConfig(scope: IFluidObject): TelemetryConfig | undefined {
  if (scope.TelemetryConfig) {
    return {
      disallowServiceTelemetry: scope.TelemetryConfig.disallowServiceTelemetry
    } as TelemetryConfig;
  }

  return undefined;
}

export function getGuestSideTelemetryConfig(scope: Pairing<IFluidObject>): TelemetryConfig | undefined {
  if (scope.TelemetryConfig) {
    return new IFrameTelemetryConfigProxy(scope.TelemetryConfig as TelemetryConfig);
  }

  return undefined;
}

class IFrameTelemetryConfigProxy implements TelemetryConfig {
  disallowServiceTelemetry?: boolean;

  public constructor(telemetryConfig: TelemetryConfig) {
    this.disallowServiceTelemetry = telemetryConfig.disallowServiceTelemetry;
  }

  public get TelemetryConfig() {
    return this;
  }
}
